import { ServiceFetch } from '../service-fetch'

export default class PaymentReceiveModel extends ServiceFetch {
    getPaymentReceiveBy = (data) => this.authFetch({
        url: 'payment-receive/getPaymentReceiveBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}